import React, { useEffect, useState } from 'react';
import Header from '../../components/global/Header';
import { Box } from '@mui/system';
import { Button, Paper } from '@mui/material';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import PersonOutlinedIcon from '@mui/icons-material/Person2Outlined';
import Colors from '../../Constant/Colors';
import StatBox from '../../components/commercial/StatBox';
import ComposedChart from '../../components/scenes/ComposedChart';
import client from '../../API/client';

const DashboardContent = () => {
  const [user, setUser] = useState(0);
  const [designer, setDesigner] = useState(0);
  const [recruiter, setRecruiter] = useState(0);
  useEffect(() => {
    getUsersCount();
  }, []);

  const getUsersCount = async () => {
    client
      .get('/admin/dashboard/get-users-count', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(async (res) => {
        setUser(res.data.Users.cnt);
        setDesigner(res.data.designer.cnt);
        setRecruiter(res.data.recruiter.cnt);
      });
  };
  return (
    <>
      <Box m="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header title="DASHBOARD" subtitle={'Welcome hardik'} />
          <Box>
            <Button
              sx={{
                backgroundColor: Colors.bgcolor,
                color: Colors.darkblue,
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '10px 20px',
              }}>
              <DownloadOutlinedIcon sx={{ mr: '10px' }} />
              Download Reports
            </Button>
          </Box>
        </Box>

        {/* Grid || Rows */}
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="140px"
          gap="20px"
          marginTop={'10px'}>
          <Box
            gridColumn="span 3"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              boxShadow: '2px 4px  10px 2px rgba(201,201,201,0.57)',
              borderRadius: '10px',
            }}>
            <StatBox
              title={user}
              subtitle="Users"
              progress="0.70"
              increase="+10%"
              icon={
                <PersonOutlinedIcon sx={{ color: 'black', fontSize: '25px' }} />
              }
            />
          </Box>
          <Box
            gridColumn="span 3"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              boxShadow: '2px 4px  10px 2px rgba(201,201,201,0.57)',
              borderRadius: '10px',
            }}>
            <StatBox
              title={designer}
              subtitle="Designer"
              progress="0.30"
              increase="+1%"
              icon={
                <PersonOutlinedIcon sx={{ color: 'blue', fontSize: '25px' }} />
              }
            />
          </Box>
          <Box
            gridColumn="span 3"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              boxShadow: '2px 4px  10px 2px rgba(201,201,201,0.57)',
              borderRadius: '10px',
            }}>
            <StatBox
              title={recruiter}
              subtitle="Recruiter"
              progress="0.80"
              increase="+4%"
              icon={
                <PersonOutlinedIcon sx={{ color: 'green', fontSize: '25px' }} />
              }
            />
          </Box>
          <Box
            gridColumn="span 3"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              boxShadow: '2px 4px  10px 2px rgba(201,201,201,0.57)',
              borderRadius: '10px',
            }}>
            <StatBox
              title="200"
              subtitle="Earnings"
              progress="0.90"
              increase="+32%"
              icon={
                <PersonOutlinedIcon
                  sx={{ color: 'purple', fontSize: '25px' }}
                />
              }
            />
          </Box>
        </Box>

        <Paper
          elevation={4}
          sx={{
            backgroundColor: 'white',
            marginTop: '25px',
            borderRadius: 3,
            padding: '35px',
          }}>
          <Box
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            alignItems="center">
            <ComposedChart />
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default DashboardContent;
